<div class="container-fluid contentHeight">
  <div class="tab-content adminContent" id="nav-tabContent">
    <div class="backgroundWhiteRound tabgrp">
      <div class="top-container">
        <h2 class="inline">
          {{'stats.keyFactors.name'|translate}}
        </h2>
        <mat-form-field>
          <mat-label>{{'stats.common.period'|translate}}</mat-label>
          <mat-select [(value)]="selectedPeriod" (selectionChange)="loadKeyFactors(true)">
            <mat-option *ngFor="let period of availablePeriods" [value]="period.value" selected> {{period.name|translate}} </mat-option>
          </mat-select>
        </mat-form-field>
        <h2 class="inline">
          :
        </h2>
      </div>
      <div *ngIf="keyfactors != null" class="keyfactors-container">
        <div *ngFor="let keyfactor of keyfactors" class="keyfactor">
          <span class="keyfactor-value primaryGreen">
            {{keyfactor.value}}
          </span>
          <span class="keyfactor-name">
            {{keyfactor.name|translate}}
          </span>
        </div>
      </div>
      <div *ngIf="keyfactors === null || keyfactors.length == 0"  class="keyfactors-container">
        <span class="loading" *ngIf="areKeyfactorsLoading">{{'stats.common.loading' | translate}}</span>
      </div>
      <div class="kf-settings" (click)="toggleKFSettings()">
        <img src="assets/stats/settings.svg" alt="" />
      </div>
    </div>
    <stats-grid [resize]="graphResizer.asObservable()" (moved)="movedGraph($event)" (resized)="resizedGraph($event)" (closed)="closedGraph($event)">
      <ng-template *ngFor="let graphProps of graphsProps; index as idx" grid-item>
        <div class="graph-contained">
          <div class="graph-title-container">
            <span class="graph-title">
              {{graphProps.graph.title|translate}}
            </span>
          </div>
          <div class="graph-filters">
            <mat-expansion-panel hideToggle #expansionPanel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{expansionPanel.expanded ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                  {{'stats.graphs.filters.name' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                  <span id="panel-desc-{{idx}}" class="graph-period" style="{{expansionPanel.expanded ? 'display: none;' : ''}}"></span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <stats-filters [graphProps]="graphProps" [graphQuery]="graphQuery" (header)="updatePanelDescription($event, idx)" (submit)="graphSubmit(graphProps.graph.dataX, graphProps.graph.dataY, $event, idx)" (sendValues)="receiveFilters($event)" (editValues)="editGraph()"></stats-filters>
            </mat-expansion-panel>
          </div>
          <div class="graph-method">
            <div class="graph-method-field">
              <ng-container *ngIf="graphProps.graph.availableShapes.length > 1; then shapeSelector; else shapeHidden"></ng-container>
              <ng-template #shapeSelector>
                <mat-form-field *ngIf="graphProps.graph.availableShapes.length > 1" class="fullwidth">
                  <mat-label>{{'stats.graphs.shapes.name' | translate}}</mat-label>
                  <mat-select [(value)]="graphProps.graph.latestShape" required>
                    <ng-container *ngFor="let availableShape of graphProps.graph.availableShapes">
                      <mat-option *ngIf="(availableShape != StatsGraphShape.MAP) || displayMap[idx]" [value]=availableShape>
                        {{getShapeName(availableShape) | translate}}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </ng-template>
              <ng-template #shapeHidden>
                <input type="hidden" (value)="graphProps.graph.latestShape" [value]=graphProps.graph.availableShapes[0]>
              </ng-template>
            </div>
            <div class="graph-method-filler">
            </div>
            <div class="graph-method-field">
            </div>
          </div>
          <div class="graph-itself">
            <mg-chart [uid]=idx [viewShape]=graphProps.graph.latestShape [title]=graphProps.graph.title (editValues)="editGraph()" (shapeChange)="graphProps.graph.latestShape = $event"></mg-chart>
          </div>
        </div>
      </ng-template>
    </stats-grid>
  </div>
</div>

<div class="top-buttons">
  <div class="save-button {{'save-button-' + (saveActive ? 'active' : 'inactive')}}" (click)="saveGraphsPrefs()" title="{{'stats.graphs.settings.saveBtn'|translate}}">
    <img src="assets/stats/save.svg" alt="" />
  </div>
  <div class="add-button" (click)="toggleAGModal()" title="{{'stats.graphs.settings.addBtn'|translate}}">
    <img src="assets/stats/plus.svg" alt="" />
  </div>
</div>

<stats-kf-modal *ngIf="showKFModal" (close)="toggleKFSettings()" (save)="saveKFSettings($event)"></stats-kf-modal>
<stats-ag-modal *ngIf="showAGModal" (close)="toggleAGModal()" (save)="addGraph($event)"></stats-ag-modal>
<stats-txt-modal *ngIf="showTXTModal" (close)="toggleTXTModal()" [text]="txtModalText"></stats-txt-modal>
